<template>
  <div>
    <card-dashboard
      id="card-projetos-encerrados"
      bg-variante="success"
      icone="fa-solid fa-file-invoice-dollar"
      titulo=""
      :valor="valor"
      titulo-modal="Projetos encerrados"
      :colunas="colunas"
      :dados="dados"
    >
      <template #titulo>
        <span> Projetos<br />encerrados </span>
      </template>
    </card-dashboard>
  </div>
</template>
<script>
import CardDashboard from "@/components/card/CardDashboard";
import DashboardExecutoraService from "@/common/services/dashboards/dashboard_executora.service";
export default {
  components: {
    CardDashboard,
  },
  mounted() {
    this.buscarDados();
  },
  data: () => ({
    valor: 0,
    colunas: [
      { key: "nomeFantasia", label: "Empresa" },
      { key: "codigo", label: "Código do projeto" },
    ],
    dados: [],
  }),
  methods: {
    buscarDados() {
      DashboardExecutoraService.projetosEncerrados(
        this.empresasSelecionada
      ).then((response) => {
        this.dados = response.data.data.map((el) => {
          return {
            nomeFantasia: el.nomeFantasia,
            codigo: el.codigoProjeto,
          };
        });
        this.valor = response.data.data.length;
      });
    },
  },
  computed: {
    empresasSelecionada: function () {
      if (!this.$store.state.app.selectedCompanyObj) return null;
      return this.$store.state.app.selectedCompanyObj.id;
    },
  },
};
</script>
<style lang="">
</style>